import { Fragment, memo } from "react";

import { getTokenChipTint, type RenderTokenChip, TOKEN_CHIP_CLASS, TOKEN_CHIP_VALUE_CLASS } from "./tokenChipTint";

const TOKEN_PATTERN = /^\{\{[^{}]*\}\}$/;
const TOKEN_SPLIT_PATTERN = /(\{\{[^{}]*\}\})/g;

type RulebookTokenTextProps = {
  text: string;
  renderChip: RenderTokenChip;
  "data-testid"?: string;
};

const tokenChipStyle = (tint: ReturnType<typeof getTokenChipTint>) => ({
  background: tint.background,
  boxShadow: `inset 0 0 0 1px ${tint.border}`,
  color: tint.color,
});

const renderTokenChip = (raw: string, chip: ReturnType<RenderTokenChip>) => {
  const tint = getTokenChipTint(chip);
  return (
    <span className={TOKEN_CHIP_CLASS} style={tokenChipStyle(tint)} title={raw} data-token={raw} data-testid="RulebookTokenText-Chip">
      {chip.label}
      {chip.value !== undefined ? <span className={TOKEN_CHIP_VALUE_CLASS}>{chip.value}</span> : null}
    </span>
  );
};

const RulebookTokenText = ({ text, renderChip, "data-testid": testId = "RulebookTokenText" }: RulebookTokenTextProps) => (
  <span data-testid={testId}>
    {text
      .split(TOKEN_SPLIT_PATTERN)
      .map((segment, index) =>
        TOKEN_PATTERN.test(segment) ? (
          <Fragment key={`${segment}-${index}`}>{renderTokenChip(segment, renderChip(segment))}</Fragment>
        ) : (
          <Fragment key={`${segment}-${index}`}>{segment}</Fragment>
        ),
      )}
  </span>
);

export default memo(RulebookTokenText);
